import React from "react";
import theme from ".";
import { ChakraProvider, createStandaloneToast } from "@chakra-ui/react";
export function CartridgeUIProvider({ children, }) {
    const { ToastContainer } = createStandaloneToast();
    return (<ChakraProvider theme={theme}>
      {children}
      <ToastContainer />
    </ChakraProvider>);
}
//# sourceMappingURL=Provider.jsx.map